<template>
  <t-table
      id="vpp-history-details"
      :columns="vppHistoryTableColumns"
      :local-data="reversedVppHistory"
      :options="vppHistoryTableOptions"
  >
    <template v-slot:calculateAutomatically="{row}">
      {{ row.calculateAutomatically ? $t("automatic") : $t("manual") | capitalize }}
    </template>
    <template v-slot:status="{row}">
      {{
        row.status === distributionVppTypes.OFFICIAL ? $t("official") : $t("placeholder") | capitalize
      }}
    </template>
    <template v-slot:addedAt="{row}">
      {{
        getFormatedTime(row.addedAt)
      }}
    </template>
    <template v-slot:addedBy="{row}">
      {{
        row.addedBy || "-"
      }}
    </template>
    <template v-slot:playcountsIneligiblePercentage="{row}">
      {{
        formatVppPlaycounts(row.playcountsIneligiblePercentage)
      }}
    </template>
    <template v-slot:playcountsUnmatchedPercentage="{row}">
      {{
        formatVppPlaycounts(row.playcountsUnmatchedPercentage)
      }}
    </template>
    <template v-slot:playcountsUsedForCalculation="{row}">
      {{
        formatVppPlaycounts(row.playcounts?.usedForCalculation)
      }}
    </template>
    <template v-slot:playcountsEligible="{row}">
      {{
        formatVppPlaycounts(row.playcounts?.eligible)
      }}
    </template>
    <template v-slot:playcountsIneligible="{row}">
      {{
        formatVppPlaycounts(row.playcounts?.ineligible)
      }}
    </template>
    <template v-slot:playcountsUnmatched="{row}">
      {{
        formatVppPlaycounts(row.playcounts?.unmatched)
      }}
    </template>
  </t-table>
</template>

<script>
import { capitalize, cloneDeep } from "lodash"
import { distributionVppTypes } from "@/constants"
import parseDate from "../../../utils/date-parser"

export default {
  name: "VPPHistory",
  props: {
    distribution: Object
  },
  data () {
    return {
      distributionVppTypes,
      vppHistoryTableOptions: {
        sortable: [],
        headings: {
          calculateAutomatically: capitalize(this.$t("calculate_vpp")),
          maker: capitalize(this.$t("maker_vpp")),
          performer: this.$t("performer_vpp"),
          status: capitalize(this.$t("vpp_type")),
          playcountsIneligiblePercentage: capitalize(this.$t("playcounts_ineligible_percentage_short")),
          playcountsUnmatchedPercentage: capitalize(this.$t("playcounts_unmatched_percentage_short")),
          playcountsUsedForCalculation: capitalize(this.$t("playcounts_used_short")),
          playcountsEligible: capitalize(this.$t("playcounts_eligible")),
          playcountsIneligible: capitalize(this.$t("playcounts_ineligible")),
          playcountsUnmatched: capitalize(this.$t("playcounts_unmatched")),
          addedAt: capitalize(this.$t("added_at")),
          addedBy: capitalize(this.$t("added_by")),
        },
      },
      vppHistoryTableColumns: [
        "calculateAutomatically",
        "maker",
        "performer",
        "status",
        "playcountsIneligiblePercentage",
        "playcountsUnmatchedPercentage",
        "playcountsUsedForCalculation",
        "playcountsEligible",
        "playcountsIneligible",
        "playcountsUnmatched",
        "addedAt",
        "addedBy"
      ]
    }
  },
  methods: {
    getFormatedTime (time) {
      if (!time) {
        return "-"
      }
      return parseDate(time, this.$config.DATETIME_FORMAT)
    },
    formatVppPlaycounts (value) {
      if (value === null || value === undefined) {
        return "-"
      }
      return this.$options.filters.formatNumber(value)
    }
  },
  computed: {
    reversedVppHistory () {
      return cloneDeep(this.distribution.vppHistory).reverse()
    },
  }
}
</script>
